var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGroupDLayer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-group-d-layer-a",
    x1: "19.379%",
    x2: "78.845%",
    y1: "13.885%",
    y2: "90.741%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A8B9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-group-d-layer-b",
    x1: "0%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DFE5F0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7EEFB",
    d: "M22,4 C28.7998277,4 34.7190076,7.77050127 37.7808515,13.3348156 C35.0758536,11.2445806 31.6832705,10 28,10 C19.163444,10 12,17.163444 12,26 C12,31.9496177 15.247386,37.1407677 20.0663794,39.8976713 C11.0346721,38.9328823 4,31.287959 4,22 C4,12.0588745 12.0588745,4 22,4 Z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    transform: "translate(12 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "url(#ic-group-d-layer-a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 9,
    r: 3,
    stroke: "url(#ic-group-d-layer-b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 20,
    r: 3,
    stroke: "url(#ic-group-d-layer-b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 3,
    stroke: "url(#ic-group-d-layer-b)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroupDLayer);
export default __webpack_public_path__ + "static/media/ic-group-d-layer.40bc1755fe9d0db5bc182302d1b3513c.svg";
export { ForwardRef as ReactComponent };